module.exports = __webpack_public_path__ + "img/code2.b665b57f.png";